<template>
  <mdb-container fluid>
    <DataTableAG
      :columns="columns"
      width="1600px"
      height="750px"
      :getcontentpath="getcontentpath"
      jsonobject="benefitcodes"
      :rowHeight="120"
    />
  </mdb-container>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbContainer } from "mdbvue";

export default {
  name: "BenefitCodeStats",
  components: {
    DataTableAG,
    mdbContainer,
  },
  props: {},
  data: () => ({
    getcontentpath: "/1.0/front/benefitcodes",
    columns: [
      {
        field: "name",
        headerName: "Nimi",
        width: 150,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "benefit_title",
        headerName: "Edun otsikko",
        width: 500,
        sortable: true,
        filter: true,
        resizable: true,
      },

      {
        field: "total",
        headerName: "Kaikki",
        width: 150,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "remaining",
        headerName: "Jäljellä olevia",
        width: 150,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "used",
        headerName: "Käytettyjä",
        width: 150,
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  methods: {

  },
  mounted() {},
};
</script>